import { gql } from '@apollo/client'

const ME_MODEL = `
    id
    fullName
    firstName
    lastName
    email
    timeZone
    availability {
        dayOfWeek
        startTime
        endTime
    }
    upcomingMeetings {
        id
    }
    membership {
        teamId
        teamName
        role
    }
`

const USER_MODEL = `
    id
    fullName
    firstName
    lastName
    email
    expert {
        id
        title
        organization {
            name
            type
        }
        publicLinks
        description
        infoFromLinkedin
        country
        status
        isBlocked
        blockReason
        functions
        medical_specialties
        technology_tags
        internal_tags
        responseRate
        numRatings
        numCompleted
        numPending
        avgRating
        stripeAccount {
            stripeId
            isConnected
        }
        hourlyRate
    }
`

export const LOAD_ME_QUERY = gql`
    query User {
        me {
            ${ME_MODEL}
        }
    }
`

export const LOAD_USER_QUERY = gql`
  query User($id: String!) {
    user(id: $id) {
      ${USER_MODEL}
    }
  }
`

export const LOAD_USER_BY_EMAIL_QUERY = gql`
    query UserByEmail($email: String!) {
        userByEmail(email: $email) {
            id
        }
    }
`

export const LOAD_MERGING_USER = gql`
    query UserByEmail($email: String!) {
        userByEmail(email: $email) {
            id
            email
            fullName
            membership {
                teamName
            }
            expert {
                id
                title
                organization {
                    name
                    type
                }
                isBlocked
                status
                profile_picture
                stripeAccount {
                    stripeId
                    isConnected
                }
                description
                country
                functions
                medical_specialties
                technology_tags
            }
            jobs {
                id
                overall_status
                meetingAt
                user {
                    id
                    email
                    fullName
                    timeZone
                }
                project {
                    id
                    title
                    type
                }
                updatedAt
            }
        }
    }
`

export const LOAD_EXPERTS_QUERY = gql`
    query Experts(
        $query: String
        $filters: ExpertFilters
        $pagination: Pagination
        $sortBy: ExpertSortBy
    ) {
        experts(
            query: $query
            filters: $filters
            pagination: $pagination
            sortBy: $sortBy
        ) {
            id
            fullName
            title
            organization {
                name
                type
            }
            hourlyRate
            profile_picture
            country
            status
            isBlocked
            stripeAccount {
                stripeId
                isConnected
            }
            functions
            medical_specialties
            technology_tags
            internal_tags
            payment_notify
            responseRate
            numCompleted
            numPending
            numRatings
            avgRating
            infoFromLinkedin
            description
            user {
                id
                firstName
                lastName
                fullName
                email
            }
        }
    }
`

export const LOAD_NUM_EXPERTS = gql`
    query Experts(
        $query: String
        $filters: ExpertFilters
        $pagination: Pagination
    ) {
        experts(query: $query, filters: $filters, pagination: $pagination) {
            id
        }
    }
`

export const LOAD_EXPERT_TAGS = gql`
    query User($id: String!) {
        user(id: $id) {
            id
            expert {
                id
                functions
                organization {
                    type
                }
                medical_specialties
                technology_tags
                internal_tags
            }
        }
    }
`

export const LOAD_EXPERT_SUMMARY_QUERY = gql`
    query Expert($id: String!) {
        expert(id: $id) {
            id
            fullName
            country
            credentials
        }
    }
`

export const LOAD_USER_EXTERNAL_ACCOUNT_STATUSES = gql`
    query User($id: String!) {
        user(id: $id) {
            id
            externalAccountStatuses {
                id
                provider
                status
                tokenExpiresAt
            }
        }
    }
`

export const UPDATE_EXPERT_INTERNAL_TAGS = gql`
    mutation UpdateExpertInternalTags($id: ID!, $internalTags: [String]) {
        updateExpertInternalTags(id: $id, internalTags: $internalTags) {
            internal_tags
        }
    }
`

export const BLOCK_EXPERT = gql`
    mutation BlockExpert($id: ID!, $reason: String) {
        blockExpert(id: $id, reason: $reason) {
            id
            isBlocked
            blockReason
        }
    }
`

export const UNBLOCK_EXPERT = gql`
    mutation UnblockExpert($id: ID!) {
        unblockExpert(id: $id) {
            id
            isBlocked
            blockReason
        }
    }
`
